import { useState, useCallback } from "react";

export function useSharePrompt() {
  const [shareData, setShareData] = useState(null);

  const promptShare = useCallback((responseData, exerciseType) => {
    const entryId = responseData?.entry_id || responseData?.record_id || responseData?.session_id;
    if (entryId) {
      setShareData({ entryId, exerciseType });
    }
  }, []);

  const closeSharePrompt = useCallback(() => setShareData(null), []);

  return { shareData, promptShare, closeSharePrompt };
}
